export default "__VITE_ASSET__DpEnCmtu__"